import { STATIC_PATH } from './helpers/constants';
__webpack_public_path__ = STATIC_PATH;
